export const h = {
	quantity: "库存",
	brand: "品牌",
	sku: "SKU",
	model: "型号",
	addCart: "加入购物车",
	buyNow: "立即购买",
	productDetail: "商品详情",
	attribute: "属性",
	quantityExits: "有货",
	quantityNone: "缺货",

	// 账单页面
	email: "邮箱",
	errorEmail: "请输入正确邮箱",
	contact: '联系方式',
	sippingAddress: '配送地址',
	name: "姓名",
	nameError: "请输入姓名",
	address1: "地址1",
	address1Error: "请输入地址1",
	address2: "地址2",
	emailCode:"邮编",
	phone:"手机号码",
	city:"城市",
	cityError:"请输入城市",
	country:"国家",
	countryError:"请输入国家",
	province:"省份",
	provinceError:"请输入省份",
	payWay:"支付方式",
	sendWay:"配送方式",
	loginText:"登录 / 注册",
	cartNum:"购物车总数",
	orderRemarks:"订单备注",
	discountCode:"请输入优惠码",
	apply:"使用",
	submitOrder:"提交订单",
	
	
	
	classify:"分类",
	price:"价格",
	allNum:"总数",
	defaultTit:"默认",
	salesLowToHigh:"销量 (低 - 高)",
	salesHighToLow:"销量 (高 - 低)",
	nameAtoZ:"名称 (A - Z)",
	nameZtoA:"名称 (Z - A)",
	priceLowtoHeight:"价格 (低 - 高)",
	priceHeighttoLow:"价格 (高 - 低)",
	selectClassfiy:"选择分类",
	goodCart:"购物车",
	checkout:"结账",
	pay:"付款",
	goods:"商品",
	num:"数量",
	total:"小计",
	action:"操作",
	del:"删除",
	priceTotal:"商品总计",
	all:"全部",
	selectd:"已选",
	goCheckout:"去结账",
	linkGoods:"相关商品",
	noData:"暂无数据",
	myOrder:"我的订单",
	changeUserInfo:"修改个人信息",
	changePassword:"修改密码",
	myAddress:"我的地址",
	myWishlist:"我的收藏",
	myRmas:"我的售后",
	userCommission:"会员佣金",
	commissionUsers:"会员关系",
	loginOut:"退出登录",
	orderId:"订单号",
	
	
	lookDetail:"查看详情",
	saleService:"申请售后",
	confirmReceivedGoods:"确认收货",
	goPay:"去支付",
	cancelOrder:"取消订单",
	
	orderDetail:"订单详情",
	created_at:"创建时间",
	status_format:"订单状态",
	total_format:"订单金额",
	payment_method_name:'支付方式',
	shipping_method_name:'配送方式',
	
	addressInfo:"地址信息",
	name:"姓名",
	address:"地址",
	payGoods:"订购商品",
	
	sendCompany:"快递公司",
	sendNum:"快递单号",
	updateTime:"更新时间",
	memo:"备注",
	payOrderAddress:"账单地址",
	allOrder:"所有订单",
	waitPay:"待支付",
	waitSend:"待发货",
	waitReceiving:"待收货",
	completed:"已完成",
	confirm:"确认",
	tips:"提示",
	cancel:'取消',
	changeHeadImg:"修改头像",
	uploadTit:"上传JEPG或PNG图片。建议300 x 300。",
	imgSizeTips:"上传头像图片大小不能超过 2 MB!",
	imgTypeTips:"上传头像图片只能是 JPG/PNG 格式!",
	serviceType:"服务类型",
	returnNum:"退换数量",
	isOpend:"是否打开包装",
	returnReason:"退换原因",
	yes:"是",
	no:"否",
	returnGoods:"退货",
	exchange:"换货",
	repair:"维修",
	reissue:"补发商品",
	refund:"仅退款",
	returnNumError:"请输入退换数量",
	
	oldPassword:"旧密码",
	newPassword:"新密码",
	confirmNewPassword:"确认新密码",
	
	wishlist:"取消收藏",
	look:"查看",
	opendPkg:"已打开包装",
	img:"图片",
	afterSales:"售后详情",
	
	balance:"可用余额",
	waitAmount:"待结算金额",
	withdrawaled:"已提现",
	withdrawal:"提现",
	allCommission:"总佣金",
	startTime:"开始时间",
	endTime:"结束时间",
	search:"搜索",
	
	rebateLevel:"返佣层级",
	CommissionRate:"佣金比例",
	commission:"佣金",
	settlementStatus:"结算状态",
	time:"时间",
	WithdrawalAmount:"提现金额",
	peleaseSelect:"请选择",
	withdrawalUser:"提现账户",
	peleaseIpt:"请输入内容",
	submitSuccess:"提交成功",
	submitSuccess:"提交成功",
	shareLink:"分享链接",
	superior:"我的直属上级",
	wu:"无",
	subordinate:"我的下级",
	addTime:"加入时间",
	userAccount:"账号",
	recommendationCode:"推荐码",
	copySuccess:"复制成功",
	subPay:"提交支付",
	iptCardholder_Name:"请输入cardholder_Name",
	copy:"复制",
	
	
	
	home:"首页",
	categoriesPage:"分类",
	brandsPage:"品牌",
	brandsPageList:"品牌商品",
	productsPage:"商品",
	wishlistPage:"我的收藏",
	accountPage:"我的订单",
	cartsPage:"购物车",
	checkoutPage:"结账",
	passwordPage:"修改密码",
	editPage:"修改信息",
	addressesPage:"修改地址",
	rmasPage:"会员关系",
	commissionPage:"会员佣金",
	success_order_checkoutPage:"订单支付",
	page_categoriesPage:"文章分类",
	userloginPage:"登录",
	pagesPage:"文章",
	
	hotGoods:"热门商品",
	newGoods:"最新商品",
	visitGoods:"浏览最多",
	allGoods:"所有商品",
	evaluation:"评价",
	
	first_name:"姓",
	first_nameError:"请输入姓",
	last_name:"名",
	last_nameError:"请输入名",
	
	comment:"内容",
	noContent:"暂无评论",
	author:"作者",
	scoreNum:"评分",
	commentTit:"评论",
	
	
	send:"发送",
	
	noPayWay:"无可用支付方式",
	noTransportation:"无可用运输方式",
	
	tkyouorder:"感谢您的下单",
	orderDate:"订单日期",
	ordeAmount:"订单金额",
	paymentAddress:"支付地址",
	zipCode:"邮政编码",
	
	customizationFee:"定制化费用"
}